import { render, staticRenderFns } from "./kdxFormTitle.g.vue?vue&type=template&id=1511b41b&scoped=true"
import script from "./kdxFormTitle.g.vue?vue&type=script&lang=js"
export * from "./kdxFormTitle.g.vue?vue&type=script&lang=js"
import style0 from "./kdxFormTitle.g.vue?vue&type=style&index=0&id=1511b41b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1511b41b",
  null
  
)

export default component.exports